import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, injectIntl, intlShape} from 'react-intl';

import messages, {errorMessages} from './messages';
import Navbar from '../../components/NavbarUnauthenticated';
import Box from '../../components/Box';
import RecoverPasswordForm from './components/RecoverForm/index';
import {SEND_RESET_PASSWORD_EMAIL} from '../../api/users/queries';
import {graphql} from 'react-apollo';

const RecoverPasswordWrapper = ({children}) => {
    return (
        <section className="hero is-fullheight alva-bg">
            <Navbar/>

            <div className="hero-body">
                <div className="container">
                    <Box isCentered={true} style={{maxWidth: '440px', minHeight: '320px', padding: '36px 60px'}}>
                        <h1 className="title" style={{textAlign: 'center'}}><FormattedMessage {...messages.title}/></h1>
                        {children}
                    </Box>
                </div>
            </div>
        </section>
    );
};

RecoverPasswordWrapper.propTypes = {
    children: PropTypes.element
};


class RecoverPasswordContainer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            success: false,
            sentSignupInstead: false,
            error: ''
        };
    }

    handleSubmit = (email) => {
        this.setState({loading: true});
        this.props.requestLink(email).then((response) => {
            const {ok, errorMessage, sentEmailType} = response.data.sendResetPasswordEmail;

            if (ok) {
                this.setState({loading: false, success: true, sentSignupInstead: sentEmailType === 'SIGNUP'});
            }
            else {
                this.setState({loading: false, error: errorMessage});
            }
        }).catch(() => {
            this.setState({loading: false, error: 'SERVER_ERROR'});
        });
    };

    render() {
        const props = this.props;
        const placeholders = {
            email: props.intl.formatMessage(messages.placeholderEmail),
            submit: props.intl.formatMessage(messages.placeholderSubmit)
        };

        const getWarning = () => {
            let {success, error} = this.state;
            let warning = '';

            if (!success && error !== '') {
                warning = props.intl.formatMessage(errorMessages[error]);
            }

            return warning;
        };

        let {loading, success} = this.state;

        if (loading === false && success === true) {
            return (
                <RecoverPasswordWrapper>
                    <p>
                        <FormattedMessage
                            {...(this.state.sentSignupInstead ? messages.didSendSignupInstead : messages.successMessage)}/>
                    </p>
                </RecoverPasswordWrapper>
            );
        }

        return (
            <RecoverPasswordWrapper>
                <div>
                    <p style={{marginBottom: '36px', fontSize: '14px', color: '#3c4c5c', fontWeight: 300}}>
                        <FormattedMessage {...messages.description}/>
                    </p>
                    <RecoverPasswordForm
                        action={this.handleSubmit}
                        loading={this.state.loading}
                        warning={getWarning()}
                        placeholders={placeholders}
                    />
                </div>
            </RecoverPasswordWrapper>
        );
    }
}

RecoverPasswordContainer.propTypes = {
    requestLink: PropTypes.func,
    intl: intlShape
};

export default graphql(SEND_RESET_PASSWORD_EMAIL, {
    props: ({mutate}) => ({
        requestLink: (email) => (
            mutate({
                variables: {data: {email}}
            })
        )
    })
})(injectIntl(RecoverPasswordContainer));

